export default "__VITE_ASSET__o7plpvaq__"